import {
  Box,
  CardContent,
  CircularProgress,
  Divider,
  Grid,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useRef, useState } from "react";
import Icon from "../../components/Elements/Icon/Icon";
import Images from "../../constant/images";
import "../Employer/Employer.css";
import "../Home/Home.css";
import ButtonComponent from "../../components/Elements/Button/Button";
import Card from "../../components/Elements/Card/Card";
import Input from "../../components/Elements/Input/Input";
import Dropdown from "../../components/Elements/Dropdown/Dropdown";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TestimonialCarousel from "../../components/TestimonialCarousel/users";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { EMAIL_REGEX, PHONE_REGEX, SHEET_API_URL } from "../../utils/Regex";
import { useFormik } from "formik";
import axios from "axios";
import { Padding } from "@mui/icons-material";
import CustomDatePicker from "../../components/Datepicker/DatePicker";
import BasicDatePicker from "../../components/Datepicker/DatePicker";
import MuiDatePicker from "../../components/Datepicker/DatePicker";
import dayjs, { Dayjs } from "dayjs";

const Employer = () => {
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(dayjs());

  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width: 768px)");

  const [isSubmitting, setIsSubmitting] = useState(false);

  const employmentTypes = [
    { label: "Permanent", value: "permanent" },
    { label: "Contract", value: "contract" },
  ];

  const experienceOptions = [
    { label: "Fresher", value: "0" },
    { label: "0-1 Years", value: "0,1" },
    { label: "1-3 Years", value: "1,3" },
    { label: "3-5 Years", value: "3,5" },
    { label: "5-10 Years", value: "5,10" },
    { label: "10+ Years", value: "10plus" },
  ];


  const formRef = useRef<HTMLDivElement>(null);
  const services = [
    {
      id: 1,
      title1: "Trusted by leading",
      title2: " multinationals",
      icon: Images.boll,
      iconBg: "transparent",
      borderColor: "#6B1D6B",
    },
    {
      id: 2,
      title1: "Flexible recruitment ",
      title2: "solutions",
      icon: Images.chair,
      iconBg: "#6B1D6B",
      borderColor: "#6B1D6B",
    },
    {
      id: 3,
      title1: "Industry oriented expertise",
      title2: "expertise",

      icon: Images.industry,
      iconBg: "transparent",
      borderColor: "#6B1D6B",
    },
  ];

  const nojobs = [
    { label: "Work from office", value: "Workfromoffice" },
    { label: "Remote", value: "Remote" },
    { label: "Hybrid", value: "Hybrid" },
  ];

  const inputarray = [
    {
      label: "Company Name",
      placeholder: "Enter Company Name",
      type:"text",
      name: "companyname",
      isdatepicker: true,
    },
    {
      label: "Contact Name",
      placeholder: "Enter Contact Name",
      name: "contactname",
      isdatepicker: true,
    },

    {
      label: "Contact Phone Number",
      placeholder: "Enter Contact Phone Number",
      name: "contactnumber",
      isdatepicker: true,
    },
    {
      label: "Contact Email Address",
      placeholder: "Enter Contact Email Address",
      name: "contactemail",
      isdatepicker: true,
    },
    {
      label: "Job Title",
      placeholder: "Enter Job Title",
      name: "jobtitle",
      isdatepicker: true,
    },
    {
      label: "Location",
      placeholder: "Enter Location",
      name: "location",
      isDropdown: true,
    },
    {
      label: "Number of Jobs",
      placeholder: "Enter Number of Jobs",
      name: "numberjobs",
      isdatepicker: true,
      type:"number",
      text:"number"
    },
    {
      label: "Proposed Start Date",
      placeholder: "dd/mm/yyyy",
      name: "startdate",
      isdatepicker: false,
    },
  ];

   const location= [
    { label: "Mumbai", value: "mumbai" },
    { label: "Bangalore", value: "bangalore" },
    { label: "Hyderabad", value: "hyderabad" },
    { label: "Chennai", value: "chennai" },
    { label: "Indore", value: "indore" },
  ]
  
  const secandInputs = [
    {
      label: "Employment Type",
      placeholder: "Employment Type",
      name: "employmenttype",
    },

    {
      label: "Work Mode",
      placeholder: "Enter Work Mode",
      name: "workmode",
    },
    {
      label: "Experience",
      placeholder: "Select Experience",
      name: "experience",
    },
  ];

  const validate = (values: any) => {
    const errors: any = {};

    // if (!values.companyname) {
    //   errors.companyname = "Required Company name";
    // }
    if (!values.companyname.trimStart()) {
  errors.companyname = "Full Name is required";
} else if (!/^[A-Za-z\s]+$/.test(values.companyname.trimStart())) {
  errors.companyname = "Only letters  are allowed";
}
   

     if (!values.contactname.trimStart()) {
  errors.contactname = "Full Name is required";
} else if (!/^[A-Za-z\s]+$/.test(values.contactname.trimStart())) {
  errors.contactname = "Only letters  are allowed";
}
    if (!values.contactname) {
      errors.contactname = "Full Name is required";
    }

    if (!values.contactemail) {
      errors.contactemail = "Email is required";
    } else if (!EMAIL_REGEX.test(values.contactemail)) {
      errors.contactemail = "Invalid email address";
    }

    if (!values.contactnumber) {
      errors.contactnumber = "Phone number is required";
    } else if (!PHONE_REGEX.test(values.contactnumber)) {
      errors.contactnumber = "Contact number must be 10 digits";
    }
    if (!values.jobtitle) {
  errors.jobtitle = "Required Job Title";
} else if (/\d/.test(values.jobtitle)) {
  errors.jobtitle = "Job Title should not contain numbers";
}
    if (!values.location) {
      errors.location = "Required Job Overview";
    }
    if (!values.joboverview) {
      errors.joboverview = "Required Job Overview";
    }
    if (!values.employmenttype) {
      errors.employmenttype = "Required Employment Type ";
    }
    if (!values.startdate) {
      errors.proposedDate = "Required Proposed Start Date ";
    }
    if (!values.experience) errors.experience = "Experience is required";
    if (!values.workmode) errors.workmode = "Work Mode is required";

   if (!values.numberjobs) {
  errors.numberjobs = "Number of jobs is required";
} else if (!/^\d+$/.test(values.numberjobs.toString())) {
  errors.numberjobs = "Only numbers are allowed";
}
    return errors;
  };

  const generateJobId = () => {
    return Math.random().toString(36).substr(2, 9);
  };
  const jobId = generateJobId();
  console.log("jobid", jobId);

  const formik = useFormik({
    initialValues: {
      companyname: "",
      contactname: "",
      contactemail: "",
      contactnumber: "",
      location: "",
      joboverview: "",
      jobtitle: "",
      employmenttype: "",
      workmode: "",
      // startdate: "",
      startdate: dayjs().format("YYYY-MM-DD"), // <-- Set default date here
      experience: "",
      numberjobs: "",
    },
    validate,
    // onSubmit: (values: any) => {
    //   console.log("Form Submitted:", values);
    // },
    onSubmit: async (values,{resetForm}) => {
      console.log("Form Submitted:", values);

      setIsSubmitting(true); // Start loader

      try {
        const response = await axios.post(
          `${SHEET_API_URL}?action=doPostHireUS`, // for hire us use action=doPostHireUS and drop resume action=doPostDrop
          JSON.stringify({
            jobId: jobId,
            fullName: values.contactname,
            emailId: values.contactemail,
            requiredService: "",
            // joboverview:values.joboverview,
            message: values.joboverview,
            workMode: values.workmode,
            experience: values.experience,
            jobTitle: values.jobtitle,
            phoneNumber: values.contactnumber,
            companyName: values.companyname,
            location: values.location,
            employmentType: values.employmenttype,
            startDate: values.startdate,
            noOfJobs: values.numberjobs,
          })
        );

        console.log("Response from API:", response.data);
        if (response.data.success) {
          // alert("Form submitted successfully!");
          toast.success("Form submitted successfully!");
                              resetForm(); // 👈 Reset the form here
        } else {
          // alert("Something went wrong. Please try again.");
          toast.error("Something went wrong. Please try again.");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        // alert("Error submitting form. Please check console.");
        toast.error("Error submitting form. Please check console.");
      } finally {
        setIsSubmitting(false); // Stop loader
      }
    },
  });

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <Box className="banner-container">
        <Box className="overlay">
          <Typography variant="h5" className="banner-text">
            {/* {t("employer.title")} */}
            Serving Clients Across Multiple Sectors
            {/* With The Correct Team, <br /> Achieve Greater Success */}
          </Typography>
        </Box>
      </Box>
      {/* mobile */}
      <Box className="banner-container-mob">
        <Box className="overlay">
          <Typography variant="h5" className="banner-text">
            {/* {t("employer.title")} */}
            Serving Clients Across 
            <br /> Multiple Sectors
          </Typography>
        </Box>
      </Box>
      <Box className="employe-responsive-card">
        {services.map(({ id, title1, title2, icon, iconBg }) => (
          <Card
            key={id}
            style={{
              width: 324,
              height: 330,
              backgroundColor: "white",
              textAlign: "center",
              borderRadius: 15,
              p: 2,
              boxShadow: "0px 0px 10px 0px #00000033",
              transition: "0.3s",
              "&:hover": { transform: "scale(1.05)" },
            }}
          >
            <CardContent>
              {/* Icon Container */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 90,
                  height: 90,
                  backgroundColor: iconBg,
                  borderRadius: 2,
                  mx: "auto",
                  my: 2,
                  boxShadow: "0px 0px 10px 0px #00000033",
                }}
              >
                <Icon src={icon} alt="" />
              </Box>

              {/* Title */}
              <Typography variant="body1" className={"employe-card"}>
                {title1}
              </Typography>
              <Typography variant="body1" className={"employe-card"}>
                {title2}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Box>
      {/* destop*/}
      <Box padding={"30px"} mt={3} className="destop-responsive">
        <Typography className="pp" lineHeight={"45px !important"}>
          {" "}
          Industries We Serve 
        </Typography>
        <Typography
          className="employe-card2-heading"
          sx={{ textAlign: "center !important" }}
          mb={4}
          mt={2}
        >
          {/* {t("employer.recruitmentServices")} */}
          Your Partner Across Industries
        </Typography>
        <Box className="service-container-employe" mt={14}>
          <Card
            className="service-card-employe2"
            style={{ background: "#E4DEEB" }}
          >
            <Box padding={"30px"}>
              {/* <Box className="service-card-employe2-small" mb={2.5}></Box> */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "white",
                  // border: `2px solid ${borderColor}`,
                  borderRadius: "15px",
                  // mx: "auto",
                  mb: 2,
                  // mt: 1,
                  boxShadow: "0px 0px 10px 0px #00000033",
                }}
              >
                <Icon src={Images.finanes} alt={""}></Icon>
              </Box>
              <Typography
                className="employe-card-heading"
                sx={{ textAlign: "left !important" }}
                mb={1}
              >
                Finance & Administrative Management
                {/* {t("home.Trust")} */}
              </Typography>
              <Typography
                className="employe-card2-heading-emp"
                sx={{ textAlign: "left !important" }}
              >
                Specialized recruitment services, connecting top talent with
                leading organizations in roles such as CFO, Accounting, HR, and
                Operations Management.
                {/* {t("home.Ensuring")} */}
              </Typography>
            </Box>
          </Card>
          <Card
            className="service-card-employe2"
            style={{ background: "#721372", marginTop: "-45px" }}
          >
            <Box padding={"30px"}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "white",
                  // border: `2px solid ${borderColor}`,
                  borderRadius: "15px",
                  // mx: "auto",
                  mb: 2,
                  // mt: 1,
                  boxShadow: "0px 0px 10px 0px #00000033",
                }}
              >
                <Icon src={Images.hospitalitysvg} alt={""}></Icon>
              </Box>{" "}
              <Typography
                className="employe-card-heading"
                color="white"
                sx={{ textAlign: "left !important" }}
                mb={1}
              >
                Hospitality & Tourism
                {/* {t("home.Trust")} */}
              </Typography>
              <Typography
                className="employe-card2-heading-emp"
                sx={{ textAlign: "left !important" }}
                color="white"
              >
                Placing skilled professionals in key roles such as Hotel
                Management, F&B, Travel, and Leisure, to deliver exceptional
                customer experiences.
                {/* {t("home.Ensuring")} */}
              </Typography>
            </Box>
          </Card>

          <Card
            className="service-card-employe2"
            style={{ background: "#E4DEEB" }}
          >
            <Box padding={"30px"}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "white",
                  // border: `2px solid ${borderColor}`,
                  borderRadius: "15px",
                  // mx: "auto",
                  mb: 2,
                  // mt: 1,
                  boxShadow: "0px 0px 10px 0px #00000033",
                }}
              >
                <Icon src={Images.healthicons} alt={""}></Icon>
              </Box>{" "}
              <Typography
                className="employe-card-heading"
                sx={{ textAlign: "left !important" }}
                mb={1}
              >
                Healthcare
                {/* {t("home.Trust")} */}
              </Typography>
              <Typography
                className="employe-card2-heading-emp"
                sx={{ textAlign: "left !important" }}
              >
                Connecting top medical professionals with leading hospitals,
                clinics, and healthcare providers in roles such as Doctors,
                Nurses, Allied Health, and Healthcare Management.
                {/* {t("home.Ensuring")} */}
              </Typography>
            </Box>
          </Card>

          <Card
            className="service-card-employe2"
            style={{ background: "#E4DEEB" }}
          >
            <Box padding={"30px"}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "white",
                  // border: `2px solid ${borderColor}`,
                  borderRadius: "15px",
                  // mx: "auto",
                  mb: 2,
                  // mt: 1,
                  boxShadow: "0px 0px 10px 0px #00000033",
                }}
              >
                <Icon src={Images.material} alt={""}></Icon>
              </Box>{" "}
              <Typography
                className="employe-card-heading"
                sx={{ textAlign: "left !important" }}
                mb={1}
              >
                Contracting & Engineering
                {/* {t("home.Trust")} */}
              </Typography>
              <Typography
                className="employe-card2-heading-emp"
                sx={{ textAlign: "left !important" }}
              >
                Sourcing skilled professionals specialized from engineering &
                contracting in key roles such as Project Management,
                Construction, Mechanical, Electrical, and Civil Engineering.
                {/* {t("home.Ensuring")} */}
              </Typography>
            </Box>
          </Card>
          <Card
            className="service-card-employe2"
            style={{ background: "#E4DEEB", marginTop: "-45px" }}
          >
            <Box padding={"30px"}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "white",
                  // border: `2px solid ${borderColor}`,
                  borderRadius: "15px",
                  // mx: "auto",
                  mb: 2,
                  // mt: 1,
                  boxShadow: "0px 0px 10px 0px #00000033",
                }}
              >
                <Icon src={Images.manufacturingsvg} alt={""}></Icon>
              </Box>{" "}
              <Typography
                className="employe-card-heading"
                sx={{ textAlign: "left !important" }}
                mb={1}
              >
                Manufacturing
                {/* {t("home.Trust")} */}
              </Typography>
              <Typography
                className="employe-card2-heading-emp"
                sx={{ textAlign: "left !important" }}
              >
                {/* {t("home.Ensuring")} */}
                Connecting top talent from leading
                organizations manufacturing in roles such as Production
                Management, Quality Control, Supply Chain, and Operations
                Management.
              </Typography>
            </Box>
          </Card>
          <Card
            className="service-card-employe2"
            style={{ background: "#E4DEEB" }}
          >
            <Box padding={"30px"}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "white",
                  // border: `2px solid ${borderColor}`,
                  borderRadius: "15px",
                  // mx: "auto",
                  mb: 2,
                  // mt: 1,
                  boxShadow: "0px 0px 10px 0px #00000033",
                }}
              >
                <Icon src={Images.logistic} alt={""} ></Icon>
              </Box>{" "}
              <Typography
                className="employe-card-heading"
                sx={{ textAlign: "left !important" }}
                mb={1}
              >
                Logistics & Transport
                {/* {t("home.Trust")} */}
              </Typography>
              <Typography
                className="employe-card2-heading-emp"
                sx={{ textAlign: "left !important" }}
              >
                {/* {t("home.Ensuring")} */}
                Transport Recruiting experts from Logistics & Transport
                industries and placing skilled professionals in key roles such
                as Supply Chain Management, Freight Forwarding, Warehousing, and
                Transportation Management.
              </Typography>
            </Box>
          </Card>

          <Card
            className="service-card-employe2"
            style={{ background: "#E4DEEB" }}
          >
            <Box padding={"30px"}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "white",
                  // border: `2px solid ${borderColor}`,
                  borderRadius: "15px",
                  // mx: "auto",
                  mb: 2,
                  // mt: 1,
                  boxShadow: "0px 0px 10px 0px #00000033",
                }}
              >
                <Icon src={Images.hugeicons} alt={""}></Icon>
              </Box>{" "}
              <Typography
                className="employe-card-heading"
                sx={{ textAlign: "left !important" }}
                mb={1}
              >
                IT & Telecom
                {/* {t("home.Trust")} */}
              </Typography>
              <Typography
                className="employe-card2-heading-emp"
                sx={{ textAlign: "left !important" }}
              >
                Connecting top talent at all levels and emphasising their
                profile-based experience in roles such as IT, Software
                Development, Network Engineering, and Telecommunications
                Management.
                {/* {t("home.Ensuring")} */}
              </Typography>
            </Box>
          </Card>
          <Card
            className="service-card-employe2"
            style={{ background: "#E4DEEB", marginTop: "-45px" }}
          >
            <Box padding={"30px"}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "white",
                  // border: `2px solid ${borderColor}`,
                  borderRadius: "15px",
                  // mx: "auto",
                  mb: 2,
                  // mt: 1,
                  boxShadow: "0px 0px 10px 0px #00000033",
                }}
              >
                <Icon src={Images.retailbulding} alt={""}></Icon>
              </Box>{" "}
              <Typography
                className="employe-card-heading"
                sx={{ textAlign: "left !important" }}
                mb={1}
              >
                Retail
                {/* {t("home.Trust")} */}
              </Typography>
              <Typography
                className="employe-card2-heading-emp"
                sx={{ textAlign: "left !important" }}
              >
                Expert recruitment solutions for Retail industries, placing
                skilled professionals in key roles such as Store Management,
                Buying, Merchandising, E-commerce, and Customer Service
                Management.
                {/* {t("home.Ensuring")} */}
              </Typography>
            </Box>
          </Card>
          <Card
            className="service-card-employe2"
            style={{ background: "#E4DEEB" }}
          >
            <Box padding={"30px"}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "white",
                  // border: `2px solid ${borderColor}`,
                  borderRadius: "15px",
                  // mx: "auto",
                  mb: 2,
                  // mt: 1,
                  boxShadow: "0px 0px 10px 0px #00000033",
                }}
              >
                <Icon src={Images.oilindustry} alt={""}></Icon>
              </Box>{" "}
              <Typography
                className="employe-card-heading"
                sx={{ textAlign: "left !important" }}
                mb={1}
              >
                Oil & Gas
                {/* {t("home.Trust")} */}
              </Typography>
              <Typography
                className="employe-card2-heading-emp"
                sx={{ textAlign: "left !important" }}
              >
                Specialized recruitment services by bringing expertise from Oil
                & Gas industries for roles such as Drilling, Exploration,
                Production, Refining, and Petroleum Engineering.
                {/* {t("home.Ensuring")} */}
              </Typography>
            </Box>
          </Card>
        </Box>
        <Box className="service-container-employes" mt={8}>
          <Card
            className="service-card-employe2"
            // style={{ background: "#E4DEEB" }}
          >
            <Icon
              src={Images.employeiconcard}
              alt={""}
              style={{ marginLeft: "-65px",width:"452px" }}
            >
              {" "}
            </Icon>
          </Card>

          <Card
            className="service-card-employe2"
            style={{ background: "#E4DEEB", marginTop: "-75px" }}
          >
            <Box padding={"30px"}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "white",
                  // border: `2px solid ${borderColor}`,
                  borderRadius: "15px",
                  // mx: "auto",
                  mb: 2,
                  // mt: 1,
                  boxShadow: "0px 0px 10px 0px #00000033",
                }}
              >
                <Icon src={Images.food} alt={""}></Icon>
              </Box>{" "}
              <Typography
                className="employe-card-heading"
                sx={{ textAlign: "left !important" }}
                mb={1}
              >
                Food
                {/* {t("home.Trust")} */}
              </Typography>
              <Typography
                className="employe-card2-heading-emp"
                sx={{ textAlign: "left !important" }}
              >
                lacing skilled professionals in Food industry, for key roles
                such as Food Manufacturing, Quality Assurance, Food Safety,
                Culinary Management, and Supply Chain Management.
                {/* {t("home.Ensuring")} */}
              </Typography>
            </Box>
          </Card>
          <Card
            className="service-card-employe2"
            // style={{ background: "#E4DEEB" }}
          >
            <Icon
              src={Images.employeiconcard2}
              alt={""}
              style={{ borderRadius: "15px" ,width:"452px"}}
            ></Icon>
          </Card>
        </Box>
      </Box>
      {/* moblile */}
      <Box className="mobile-responsive">
        <Typography className="pp" textTransform={"capitalize"}>
          {" "}
          Industries We Serve 
        </Typography>
        <Typography
          className="employe-card2-heading"
          sx={{ textAlign: "center !important" }}
          mb={2}
          // mt={2}
        >
          {/* {t("employer.recruitmentServices")} */}
          Your Partner Across Industries
        </Typography>
        <Box className="service-container-employe">
          <Card
            className="service-card-employe2"
            style={{ background: "#E4DEEB", Padding: "30px" }}
          >
            <Box padding={"30px"}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "white",
                  borderRadius: "15px",
                  mb: 2,
                  boxShadow: "0px 0px 10px 0px #00000033",
                }}
              >
                <Icon src={Images.finanes} alt={""}></Icon>
              </Box>
              <Typography
                className="employe-card-heading"
                sx={{ textAlign: "left !important" }}
                mb={1}
              >
                Finance & Administrative Management
                {/* {t("home.Trust")} */}
              </Typography>
              <Typography
                className="employe-card2-heading-emp"
                sx={{ textAlign: "left !important", Padding: "30px" }}
              >
                Specialized recruitment services, connecting top talent with
                leading organizations in roles such as CFO, Accounting, HR, and
                Operations Management.
                {/* {t("home.Ensuring")} */}
              </Typography>
            </Box>
          </Card>
          <Card
            className="service-card-employe2"
            style={{ background: "#721372", Padding: "30px" }}
          >
            <Box padding={"30px"}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "white",
                  // border: `2px solid ${borderColor}`,
                  borderRadius: "15px",
                  // mx: "auto",
                  mb: 2,
                  // mt: 1,
                  boxShadow: "0px 0px 10px 0px #00000033",
                }}
              >
                <Icon src={Images.hospitalitysvg} alt={""}></Icon>
              </Box>{" "}
              <Typography
                className="employe-card-heading"
                color="white"
                sx={{ textAlign: "left !important" }}
                mb={1}
              >
                Hospitality & Tourism
                {/* {t("home.Trust")} */}
              </Typography>
              <Typography
                className="employe-card2-heading-emp"
                sx={{ textAlign: "left !important" }}
                color="white"
              >
                Placing skilled professionals in key roles such as Hotel
                Management, F&B, Travel, and Leisure, to deliver exceptional
                customer experiences.
                {/* {t("home.Ensuring")} */}
              </Typography>
            </Box>
          </Card>
          <Card className="service-card-employe2" style={{ Padding: "30px" }}>
            <Icon
              src={Images.employeiconcard}
              alt={""}
              style={{ width: "105%", marginLeft: "-20px" }}
            >
              {" "}
            </Icon>
          </Card>
          <Card
            className="service-card-employe2"
            style={{ background: "#E4DEEB", Padding: "30px" }}
          >
            <Box padding={"30px"}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "white",
                  // border: `2px solid ${borderColor}`,
                  borderRadius: "15px",
                  // mx: "auto",
                  mb: 2,
                  // mt: 1,
                  boxShadow: "0px 0px 10px 0px #00000033",
                }}
              >
                <Icon src={Images.healthicons} alt={""}></Icon>
              </Box>{" "}
              <Typography
                className="employe-card-heading"
                sx={{ textAlign: "left !important" }}
                mb={1}
              >
                Healthcare
                {/* {t("home.Trust")} */}
              </Typography>
              <Typography
                className="employe-card2-heading-emp"
                sx={{ textAlign: "left !important" }}
              >
                Connecting top medical professionals with leading hospitals,
                clinics, and healthcare providers in roles such as Doctors,
                Nurses, Allied Health, and Healthcare Management.
                {/* {t("home.Ensuring")} */}
              </Typography>
            </Box>
          </Card>
          <Card
            className="service-card-employe2"
            style={{ background: "#E4DEEB", Padding: "30px" }}
          >
            <Box padding={"30px"}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "white",
                  // border: `2px solid ${borderColor}`,
                  borderRadius: "15px",
                  // mx: "auto",
                  mb: 2,
                  // mt: 1,
                  boxShadow: "0px 0px 10px 0px #00000033",
                }}
              >
                <Icon src={Images.material} alt={""}></Icon>
              </Box>{" "}
              <Typography
                className="employe-card-heading"
                sx={{ textAlign: "left !important" }}
                mb={1}
              >
                Contracting & Engineering
                {/* {t("home.Trust")} */}
              </Typography>
              <Typography
                className="employe-card2-heading-emp"
                sx={{ textAlign: "left !important" }}
              >
                Sourcing skilled professionals specialized from engineering &
                contracting in key roles such as Project Management,
                Construction, Mechanical, Electrical, and Civil Engineering.
                {/* {t("home.Ensuring")} */}
              </Typography>
            </Box>
          </Card>
          <Card
            className="service-card-employe2"
            style={{ background: "#E4DEEB", Padding: "30px" }}
          >
            <Box padding={"30px"}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "white",
                  // border: `2px solid ${borderColor}`,
                  borderRadius: "15px",
                  // mx: "auto",
                  mb: 2,
                  // mt: 1,
                  boxShadow: "0px 0px 10px 0px #00000033",
                }}
              >
                <Icon src={Images.manufacturingsvg} alt={""}></Icon>
              </Box>{" "}
              <Typography
                className="employe-card-heading"
                sx={{ textAlign: "left !important" }}
                mb={1}
              >
                Manufacturing
                {/* {t("home.Trust")} */}
              </Typography>
              <Typography
                className="employe-card2-heading-emp"
                sx={{ textAlign: "left !important" }}
              >
                {/* {t("home.Ensuring")} */}
                Connecting top talent from leading
                organizations manufacturing in roles such as Production
                Management, Quality Control, Supply Chain, and Operations
                Management.
              </Typography>
            </Box>
          </Card>
          <Card
            className="service-card-employe2"
            style={{ background: "#E4DEEB", Padding: "30px" }}
          >
            <Box padding={"30px"}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "white",
                  // border: `2px solid ${borderColor}`,
                  borderRadius: "15px",
                  // mx: "auto",
                  mb: 2,
                  // mt: 1,
                  boxShadow: "0px 0px 10px 0px #00000033",
                }}
              >
                <Icon src={Images.logistic} alt={""}></Icon>
              </Box>{" "}
              <Typography
                className="employe-card-heading"
                sx={{ textAlign: "left !important" }}
                mb={1}
              >
                Logistics & Transport
                {/* {t("home.Trust")} */}
              </Typography>
              <Typography
                className="employe-card2-heading-emp"
                sx={{ textAlign: "left !important" }}
              >
                {/* {t("home.Ensuring")} */}
                Transport Recruiting experts from Logistics & Transport
                industries and placing skilled professionals in key roles such
                as Supply Chain Management, Freight Forwarding, Warehousing, and
                Transportation Management.
              </Typography>
            </Box>
          </Card>
          <Card
            className="service-card-employe2"
            style={{ background: "#E4DEEB", Padding: "30px" }}
          >
            <Box padding={"30px"}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "white",
                  // border: `2px solid ${borderColor}`,
                  borderRadius: "15px",
                  // mx: "auto",
                  mb: 2,
                  // mt: 1,
                  boxShadow: "0px 0px 10px 0px #00000033",
                }}
              >
                <Icon src={Images.hugeicons} alt={""}></Icon>
              </Box>{" "}
              <Typography
                className="employe-card-heading"
                sx={{ textAlign: "left !important" }}
                mb={1}
              >
                IT & Telecom
                {/* {t("home.Trust")} */}
              </Typography>
              <Typography
                className="employe-card2-heading-emp"
                sx={{ textAlign: "left !important" }}
              >
                Connecting top talent at all levels and emphasising their
                profile-based experience in roles such as IT, Software
                Development, Network Engineering, and Telecommunications
                Management.
                {/* {t("home.Ensuring")} */}
              </Typography>
            </Box>
          </Card>
          <Card
            className="service-card-employe2"
            style={{ background: "#E4DEEB", Padding: "30px" }}
          >
            <Box padding={"30px"}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "white",
                  // border: `2px solid ${borderColor}`,
                  borderRadius: "15px",
                  // mx: "auto",
                  mb: 2,
                  // mt: 1,
                  boxShadow: "0px 0px 10px 0px #00000033",
                }}
              >
                <Icon src={Images.retailbulding} alt={""}></Icon>
              </Box>{" "}
              <Typography
                className="employe-card-heading"
                sx={{ textAlign: "left !important" }}
                mb={1}
              >
                Retail
                {/* {t("home.Trust")} */}
              </Typography>
              <Typography
                className="employe-card2-heading-emp"
                sx={{ textAlign: "left !important" }}
              >
                Expert recruitment solutions for Retail industries, placing
                skilled professionals in key roles such as Store Management,
                Buying, Merchandising, E-commerce, and Customer Service
                Management.
                {/* {t("home.Ensuring")} */}
              </Typography>
            </Box>
          </Card>
          <Card
            className="service-card-employe2"
            style={{ background: "#E4DEEB", Padding: "30px" }}
          >
            <Box padding={"30px"}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "white",
                  // border: `2px solid ${borderColor}`,
                  borderRadius: "15px",
                  // mx: "auto",
                  mb: 2,
                  // mt: 1,
                  boxShadow: "0px 0px 10px 0px #00000033",
                }}
              >
                <Icon src={Images.oilindustry} alt={""}></Icon>
              </Box>{" "}
              <Typography
                className="employe-card-heading"
                sx={{ textAlign: "left !important" }}
                mb={1}
              >
                Oil & Gas
                {/* {t("home.Trust")} */}
              </Typography>
              <Typography
                className="employe-card2-heading-emp"
                sx={{ textAlign: "left !important" }}
              >
                Specialized recruitment services by bringing expertise from Oil
                & Gas industries for roles such as Drilling, Exploration,
                Production, Refining, and Petroleum Engineering.
                {/* {t("home.Ensuring")} */}
              </Typography>
            </Box>
          </Card>
        </Box>
        <Box className="service-container-employes" mt={8}>
          <Card
            className="service-card-employe2"
            style={{
              background: "#E4DEEB",
              marginTop: "-45px",
              Padding: "30px",
            }}
          >
            <Box padding={"30px"}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "white",
                  // border: `2px solid ${borderColor}`,
                  borderRadius: "15px",
                  // mx: "auto",
                  mb: 2,
                  // mt: 1,
                  boxShadow: "0px 0px 10px 0px #00000033",
                }}
              >
                <Icon src={Images.food} alt={""}></Icon>
              </Box>{" "}
              <Typography
                className="employe-card-heading"
                sx={{ textAlign: "left !important" }}
                mb={1}
              >
                Food
                {/* {t("home.Trust")} */}
              </Typography>
              <Typography
                className="employe-card2-heading-emp"
                sx={{ textAlign: "left !important" }}
              >
                lacing skilled professionals in Food industry, for key roles
                such as Food Manufacturing, Quality Assurance, Food Safety,
                Culinary Management, and Supply Chain Management.
                {/* {t("home.Ensuring")} */}
              </Typography>
            </Box>
          </Card>
          <Card
            className="service-card-employe2"
            style={{ background: "#E4DEEB", Padding: "30px" }}
          >
            <Icon
              src={Images.employeiconcard2}
              alt={""}
              style={{ borderRadius: "15px" }}
            ></Icon>
          </Card>
        </Box>
      </Box>
      {/*  */}
      <Box className="globalreach">
        <Box width={isMobile ? "100%" : "50%"}>
          <Box className="global-reach-container">
            {/* Background Image with Overlay */}
            <Box className="global-reach-background">
              <Box className="global-reach-content">
                <Typography variant="h5" className="heading">
                  Global Reach
                </Typography>
                <Typography variant="body1" className="home-left-employe-box">
                  Our strategy is to tailor our recruitment and advisory
                  services for all industries depending on their business
                  requirements and needs. We can offer you a full suite of
                  services to make your hiring goals successful.
                </Typography>
              </Box>
            </Box>

            {/* Horizontal Line */}
            <Divider className="global-reach-divider" />

            {/* Menu Section (Instead of Tabs) */}
            <Box className="global-reach-menu">
              <Box className="menu-item">East Europe</Box>
              <Icon src={Images.tabvricon} alt={""}></Icon>

              <Box className="menu-item">Arab Countries</Box>
              <Icon src={Images.tabvricon} alt={""}></Icon>

              <Box className="menu-item">Africa</Box>
              <Icon src={Images.tabvricon} alt={""}></Icon>

              <Box className="menu-item">Asia</Box>
            </Box>
          </Box>
        </Box>
        <Box width={isMobile ? "100%" : "50%"}>
          <Icon src={Images.cloud} alt={""} className="map-icon"></Icon>
        </Box>
      </Box>
      {/*  */}
      <Box mt={4} mb={5}>
        <TestimonialCarousel></TestimonialCarousel>
      </Box>

      <Box className="employe-form" ref={formRef}>
        {" "}
        {/* 👈 Add ref here */}
        <Card className={"form-card"}>
          <Typography variant="h6" className="pp">
            Hire With Us {/* {t("employer.hireUs")} */}
          </Typography>
          <form
            className="formStyle"
            onSubmit={(e) => {
              e.preventDefault();
              console.log("🔵 Form onSubmit triggered");
              console.log("⚠️ Form errors:", formik.errors); // ✅ Check if there are errors
              formik.handleSubmit();
            }}
          >
            <Grid
              container
              spacing={3}
              justifyContent="space-between"
              padding={"40px"}
            >
              {inputarray.map((input, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  key={index}
                  paddingTop={"40px !important"}
                >
                  <Box>
                    {/* {input.isdatepicker ? ( */}
                    {input.isDropdown ? (
                      <Dropdown
                        // className="configuration"
                        className="Login"
                        placeholder={input.placeholder}
                        name={input.name}
                        id={input.name}
                        label={input.label}
                        options={location}
                       

                        onHandleChange={(value: string) => {
                          formik.setFieldValue(input.name, value);
                          // formik.setTouched({ ...formik.touched, [input.name]: true });
                        }}
                        value={(formik as any).values[input.name]}
                        error={
                          (formik as any).errors[input.name] &&
                          (formik as any).touched[input.name]
                            ? (formik as any).errors[input.name]
                            : ""
                        }
                        onBlur={formik.handleBlur}
                        touched={(formik as any).touched[input.name]}
                      />
                    ) : input.isdatepicker === false ? (
                      <MuiDatePicker
                        className="datepicker"
                        label={input.label}
                        value={
                          formik.values.startdate
                            ? dayjs(formik.values.startdate)
                            : null
                        }
                        onChange={(date: Dayjs | null) => {
                          const formatted = date
                            ? date.format("YYYY-MM-DD")
                            : "";
                          formik.setFieldValue("startdate", formatted);
                        }}
                      />
                    ) : (
                      <Input
                        className="Login"
                        label={input.label}
                        placeholder={input.placeholder}
                        name={input.name}
                        id={input.name}
                        value={(formik as any)?.values[input.name]}
                        onChange={formik.handleChange}
                        error={
                          (formik as any).errors[input.name] &&
                          (formik as any).touched[input.name]
                            ? (formik as any).errors[input.name]
                            : ""
                        }
                        onBlur={formik.handleBlur}
                        touched={(formik as any).touched[input.name]}
                      />
                    )}
                  </Box>
                </Grid>
              ))}

              <Grid item xs={12}>
                <label htmlFor="message" className="text-area-label">
                  Job Overview
                </label>
                <textarea
                  className="text-area"
                  placeholder="Job Overview"
                  name="joboverview"
                  value={formik.values.joboverview}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.errors.joboverview && formik.touched.joboverview && (
                  <Typography color="error" variant="body2">
                    {(formik as any).errors.joboverview}
                  </Typography>
                )}
                {/* <FileUploadForm /> */}
              </Grid>
              {secandInputs.map((input, index) => (
                <Grid
                  item
                  xs={12}
                  sm={4}
                  md={4}
                  key={index}
                  paddingTop={"40px !important"}
                >
                  <Box>
                    <Dropdown
                      // className="configuration"
                      className="Login"
                      placeholder={input.placeholder}
                      name={input.name}
                      id={input.name}
                      label={input.label}
                      options={
                        input.name === "workmode"
                          ? nojobs // 👈 pass different options for number of jobs
                          : input.name === "experience"
                          ? experienceOptions
                          : employmentTypes // 👈 default options for employment type
                      }
                      // options={
                      //   input.name === "experience"
                      //     ? experienceOptions
                      //     : input.name === "nationality"
                      //     ? nationalities
                      //     : designations // default fallback
                      // }

                      onHandleChange={(value: string) => {
                        formik.setFieldValue(input.name, value);
                        // formik.setTouched({ ...formik.touched, [input.name]: true });
                      }}
                      value={(formik as any).values[input.name]}
                      error={
                        (formik as any).errors[input.name] &&
                        (formik as any).touched[input.name]
                          ? (formik as any).errors[input.name]
                          : ""
                      }
                      onBlur={formik.handleBlur}
                      touched={(formik as any).touched[input.name]}
                    />
                  </Box>
                </Grid>
              ))}
              <Grid item xs={12}>
                <ButtonComponent
                  type="submit"
                  className={"HireButton"}
                  style={{ background: "#741374", color: "white" }}
                  // onClick={handleSubmit}
                  disable={isSubmitting}
                >
                  {/* {t("contacts.submit")} */}
                  {isSubmitting ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    "Submit"
                  )}
                </ButtonComponent>
              </Grid>
            </Grid>
          </form>
        </Card>
      </Box>
      <Box
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        bgcolor={"#741374"}
        padding={"50px"}
        gap={"20px"}
      >
        <Typography className="heading" color="white">
          Connect With Us For All Your HR & Recruitment Services{" "}
        </Typography>
        {/* <Box display={"flex"} justifyContent={"center"}> */}
        <Link to={"/contact"}>
          <ButtonComponent
            type={"button"}
            className={"talentButton"}
            style={{ color: "#741374", background: "white" }}
          >
            {" "}
            Contact US
            {/* {t("employer.hireTalentButton")} */}
          </ButtonComponent>
        </Link>
        {/* </Box> */}
      </Box>{" "}
      {/* <div className="container">
  <div className="rightdiv">Right Div</div>
  <div className="leftdiv">Left Div</div>
</div> */}
    </>
  );
};
export default Employer;

{
  /* <div>
  <div className="rightdiv"></div>
  <div className="leftdiv"></div>
</div> */
}
